<template>
  <div>
    <template v-if="versionList.length">
      <v-card
        v-for="version in versionList"
        :key="version.id"
        border
        class="mb-3">
        <v-card-text>
          <div class="d-flex align-center justify-space-between ga-3">
            <div class="d-flex align-center ga-3">
              <div class="icon--blue">
                <v-icon icon="mdi-history"></v-icon>
              </div>
              <div>
                <div class="d-flex align-center ga-2 flex-wrap">
                  <div class="font-weight-bold font-size-15">
                    Версія {{ version.version }}
                  </div>
                  <v-chip
                    v-if="version.isActive"
                    color="success"
                    size="small"
                    variant="tonal">
                    Активна
                  </v-chip>
                </div>
                <div class="text-disabled">
                  {{ new CustomDate(version.created_at).toString() }}
                </div>
              </div>
            </div>

            <div>
              <v-btn
                :disabled="version.isActive"
                :loading="$loading.isLoading(`versionRollback_${version.id}`)"
                color="primary"
                density="comfortable"
                variant="outlined"
                @click="versionRollback(version.id)">
                {{ version.isActive ? 'Поточна версія' : 'Зробити активною' }}
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </template>

    <empty-section
      v-else
      description="Нова версія документа зʼявиться тут після першого збереження змін"
      title="Версій ще немає"></empty-section>
  </div>
</template>

<script lang="ts" setup>
import EmptySection from '@/components/EmptySection.vue'
import { CustomDate } from 'best-modules/utils'
import { useDocument } from '../document'

defineOptions({
  name: 'Versions',
})

const { versionList, versionRollback } = useDocument()
</script>
